export default __webpack_public_path__ + "static/media/electrocar.61ba644b.jpeg";